import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useImagesLoaded } from '../../../../hooks/useImagesLoaded';
import { COLOR_BLACK, COLOR_WHITE } from '../../../colors';
import { ROBOTO_SLAB } from '../../../fonts';
import { Arrow, FairHousingLogo } from '../../icons';

const COPYRIGHT_YEAR = new Date().getFullYear();
const useStyles = makeStyles((theme)=> ({
    container: {
        display: 'flex',
        height: '100%',
        fontFamily: ['"Roboto Slab"', 'serif'],
        position: 'relative',
        backgroundColor: COLOR_WHITE,
    },
    contentWrap: {
        textAlign: 'left',
        minWidth: '100%',
        height: '100%',
        boxSizing: 'border-box',
        padding: '50px',
        fontSize: '32px',
        lineHeight: '48px',
        backgroundImage: 'url("./images/Notable/bg-coins.jpg")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        position: 'relative',
    },
    heading: {
        fontSize: '50px',
        lineHeight: '64px',
        fontWeight: 700,
        color: COLOR_WHITE,
        padding: '0 140px 28px 0',
    },
    body: {
        color: COLOR_WHITE,
        paddingRight: '140px',
    },
    readMore: {
        marginTop: 36,
        fontSize: '40px',
        lineHeight: '32px',
        color: COLOR_WHITE,
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    arrow: {
        marginLeft: 20,
    },
    watermark: {
        position: 'absolute',
        left: '50%',
        bottom: '16%',
        zIndex: 9999,

        '& img': {
            position: 'relative',
            width: 400,
            height: 400,
            left: '-50%',
        },
    },
    disclaimerWrap: {
        position: 'absolute',
        bottom: 18,
        left: 50,
        color: COLOR_WHITE,
        fontSize: '16px',
        lineHeight: '22px',
        fontFamily: ['Arial', 'sans-serif'],
    },
    disclaimer: {
        marginTop: 3,
    },
    fairHousing: {
        position: 'absolute',
        bottom: 20,
        right: 50,
    },
}));


export default function Coins({
    templateContent = {},
    onImagesLoaded = null,
}) {
    const classes = useStyles();
    const {
        title,
        body,
        watermark = false,
    } = templateContent || {};
    const bgImage = './images/Notable/bg-coins.jpg';
    const loadedBgs = useImagesLoaded([bgImage]);
    const whiteBodyTextHtml = (body || '')
        .replace(/(\W?)color=".*"/ig, `$1color="${COLOR_WHITE}"`);

    useEffect(() => {
        if(loadedBgs && !window.isLoaded) {
            if(typeof onImagesLoaded === 'function') {
                onImagesLoaded();
            } else {
                window.isLoaded = true;
            }
        }
        return ()=> {
            window.isLoaded = false;
        };
    }, [loadedBgs, onImagesLoaded]);


    return (
        <>
            <link rel="stylesheet" href={ROBOTO_SLAB} />
            <div className={classes.container}>
                <div className={classes.contentWrap}>
                    <div className={classes.content}>
                        <div className={classes.heading}>
                            {title}
                        </div>

                        {body && (<div className={classes.body} dangerouslySetInnerHTML={{__html: whiteBodyTextHtml}}></div>)}

                        <div className={classes.readMore}>
                            <div>
                                Read more
                            </div>
                            <div className={classes.arrow}>
                                <Arrow circleFillColor={COLOR_WHITE} arrowFillColor={COLOR_BLACK} />
                            </div>
                        </div>
                    </div>
                </div>
                {watermark && (<div className={classes.watermark}>
                    <img src="./images/watermark-stamp.svg" alt="Watermark" />
                </div>)}


                {/* Disclaimer */}
                <div className={classes.disclaimerWrap}>
                    <img src="./images/lr-logo-disclaimer-white.svg" height={20} alt="LR Logo" />
                    <div className={classes.disclaimer}>
                        &copy; ListReports {COPYRIGHT_YEAR}, all rights reserved
                    </div>
                </div>

                <div className={classes.fairHousing}><FairHousingLogo height={24} /></div>
            </div>
        </>
    );
}
